
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gNwi_bnC7Fm0h0li7Dd01tR2BY_45YvZKEAoLIw62nU0Q0Meta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexSGy3x3YYHUNpq0yGD7ZM1co7wPXIvpNNqGgq8GEulqoMeta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search8LJLqBZb9_45gJvtPBIe1EPr4b_45TXT_VhY24aq_45UrVz0MMeta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexSZCPiTkbgIzYFG1Tkum0AUO0SGH7mvK3SOKaB7w5pekMeta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93h9lmTxw5BuLirAcivOjSTp6iOncatTh3NEsYccqg3DMMeta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexLgoXwtlv5mocCUv7iIqy5uyku4tQ1X4OGKAvOdcP7IUMeta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93wAqz_45Iu83dnLqLDsIyMcqOmol_7_45PKs46FeB2Ug5MhUMeta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indext3BEKc1aR4rMLZ4dU7X6LACvGPM5dDuYojM22yTNDTwMeta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93HrgN29G3XJCBQUdYDF5CLnb0RaWN_45BN8F7zpIJ5vz40Meta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexFB_68wVTZ0crh7L_45_ygj_G89wEI9w_NTDMml_C_450NGgMeta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index3vjdBAf66bz0dGPg18NkqO8OsfyOjqZyN4xjxzqn3FQMeta } from "/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexLgoXwtlv5mocCUv7iIqy5uyku4tQ1X4OGKAvOdcP7IUMeta || {},
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indext3BEKc1aR4rMLZ4dU7X6LACvGPM5dDuYojM22yTNDTwMeta || {},
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexFB_68wVTZ0crh7L_45_ygj_G89wEI9w_NTDMml_C_450NGgMeta || {},
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index3vjdBAf66bz0dGPg18NkqO8OsfyOjqZyN4xjxzqn3FQMeta || {},
    component: () => import("/codebuild/output/src729208663/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]